import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDataEndPoint, updateDataEndPoint } from "app/utils/constants/paths";
import axiosApiInstance from "app/services/axios";
import { DATASOURCE_CONFIG } from "app/config";
import { addslashes } from "app/utils/utils";
import uuid from "react-uuid";
const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  submitLoading: false,
  privateMarketPlaceList: [],
  //TargtingTypeOptions: {},
  //isTargetingTypesLoaded: false,
  locationGroupLoading: false,
  //SupplyInventoryLoading: false,
};

export const GetAllPrivateMarketPlaceListThunk = createAsyncThunk(
  "privatemarketplace/GetAllPrivateMarketPlaceListThunk",
  async (payload) => {
    var isSysAdmin = payload?.authUserData?.is_sys_admin;
    let userId = payload?.authUserData?.user_id;
    let condition = [];
    let dealQuery = "";
    if (
      payload?.search != "" &&
      payload?.search != undefined &&
      payload?.search != null
    ) {
      condition.push(
        "deals.name " +
          DATASOURCE_CONFIG.QUERY_LIKE +
          " '%" +
          payload.search +
          "%'"
      );
    }

    let authBidAccounts = [];
    if (isSysAdmin != 1) {
      authBidAccounts = payload.authUserData?.user_assoc_bidders
        ? payload.authUserData?.user_assoc_bidders
        : [];
      if (authBidAccounts.length > 0) {
        condition.push(
          " deals.dealid=assoc.dealid and assoc.bidder_id  IN ('" +
            authBidAccounts.join("','") +
            "')"
        );
      }
    }
    console.log("condition", condition);
    let where = "";
    condition.push("deals.status !='2'");
    if (condition.length > 0) {
      where = "where " + condition.join(" and ") + "";
    }
    console.log("where", where);
    if (isSysAdmin == "1") {
      dealQuery =
        "SELECT deals.id,deals.dealid,deals.name,deals.activate_time,deals.expire_time,deals.status FROM " +
        tablePrefix +
        "rtb_deals as deals " +
        where +
        " order by deals.creation_date desc;";
    } else {
      let nameSearchCondition = "";
      if (
        payload?.search != "" &&
        payload?.search != undefined &&
        payload?.search != null
      ) {
        nameSearchCondition =
          " and deals.name " +
          DATASOURCE_CONFIG.QUERY_LIKE +
          " '%" +
          payload.search +
          "%'";
      }
      dealQuery =
        "select id,dealid,name,activate_time,expire_time,status from ((select deals.id,deals.dealid,deals.name,deals.activate_time,deals.expire_time,deals.status FROM " +
        tablePrefix +
        "rtb_deals AS deals," +
        tablePrefix +
        "rtb_dealid_bidder_assoc as assoc " +
        where +
        " order by deals.creation_date desc) UNION (select deals.id,deals.dealid,deals.name,deals.activate_time,deals.expire_time,deals.status from " +
        tablePrefix +
        "rtb_deals AS deals where deals.created_by='" +
        userId +
        "'" +
        nameSearchCondition +
        " order by deals.creation_date desc)) A";
    }

    const queryBody = {
      queries: [
        {
          query: dealQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const CreateUpdatePrivateMarketPlaceDetailsThunk = createAsyncThunk(
  "privatemarketplace/CreateUpdatePrivateMarketPlaceDetailsThunk",
  async (payload) => {
    let insertUpdateDealBidderQuery = "";
    if (payload.action == "add") {
      insertUpdateDealBidderQuery =
        "insert into " +
        tablePrefix +
        "rtb_deals (id,name,dealid,activate_time,expire_time,floor,auction_type,firstlook,dealid_link_to_select_seat,target_countries,target_size,daily_budget,daily_impressions,qps,target_app_language,target_app,target_cat,target_pubs,target_placements,target_supply_deal_id,target_devicetype,target_device_os,target_gender,target_age,created_by,target_segments,segments_conditions,segments_conditions_ui,target_skippable,creation_date,updated) values ('" +
        payload.id +
        "','" +
        addslashes(payload.name) +
        "','" +
        payload.dealId +
        "','" +
        payload.startDate +
        "','" +
        payload.endDate +
        "','" +
        payload.floor +
        "','" +
        payload.auction_type +
        "','" +
        payload.first_look +
        "','" +
        payload.link_deal +
        "','" +
        payload.country +
        "','" +
        payload.target_size +
        "','" +
        payload.daily_budget +
        "','" +
        payload.daily_impressions +
        "','" +
        payload.qps +
        "','" +
        payload.target_app_language +
        "','" +
        payload.target_app +
        "','" +
        payload.target_cats +
        "','" +
        payload.target_pubs +
        "','" +
        payload.target_placements +
        "','" +
        payload.target_supply_deal_id +
        "','" +
        payload.target_devicetype +
        "','" +
        payload.target_device_os +
        "','" +
        payload.target_gender +
        "','" +
        payload.target_age +
        "','" +
        payload.created_by +
        "','" +
        payload.target_segments +
        "','" +
        payload.segments_conditions +
        "','" +
        addslashes(payload.segments_conditions_ui) +
        "','" +
        payload.target_skippable +
        "'," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        "," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ")";
    } else {
      var inventoryTabFields = "";
      if (payload?.update_inventory_tab) {
        inventoryTabFields =
          ",target_pubs='" +
          payload.target_pubs +
          "',target_placements='" +
          payload.target_placements +
          "',target_supply_deal_id='" +
          payload.target_supply_deal_id +
          "',target_app_language='" +
          payload.target_app_language +
          "',target_app='" +
          payload.target_app +
          "',target_cat='" +
          payload.target_cats +
          "',target_skippable='" +
          payload.target_skippable +
          "'";
      }

      insertUpdateDealBidderQuery =
        "update " +
        tablePrefix +
        " rtb_deals set name='" +
        addslashes(payload.name) +
        "',activate_time='" +
        payload.startDate +
        "',expire_time='" +
        payload.endDate +
        "',floor='" +
        payload.floor +
        "',auction_type='" +
        payload.auction_type +
        "',firstlook='" +
        payload.first_look +
        "',dealid_link_to_select_seat='" +
        payload.link_deal +
        "',target_countries='" +
        payload.country +
        "',target_size='" +
        payload.target_size +
        "',daily_budget='" +
        payload.daily_budget +
        "',daily_impressions='" +
        payload.daily_impressions +
        "',qps='" +
        payload.qps +
        "',target_devicetype='" +
        payload.target_devicetype +
        "',target_device_os='" +
        payload.target_device_os +
        "',target_gender='" +
        payload.target_gender +
        "',target_age='" +
        payload.target_age +
        "',target_segments='" +
        payload.target_segments +
        "',segments_conditions='" +
        payload.segments_conditions +
        "',segments_conditions_ui='" +
        addslashes(payload.segments_conditions_ui) +
        "',updated=" +
        DATASOURCE_CONFIG.CURRENT_DATE +
        " " +
        inventoryTabFields +
        " where dealid='" +
        payload.id +
        "'";
    }
    let bidderAssocQueryArr = [];
    if (payload.action != "add") {
      // let deletedArr = payload.prevEditCaseBids.filter(
      //   (val) => !payload.bidderIds.includes(val)
      // );
      // let commonArr = payload.bidderIds.filter((val) =>
      //   payload.prevEditCaseBids.includes(val)
      // );

      if (payload.deleteBidders.length > 0) {
        var deleteString = "'" + payload.deleteBidders.join("','") + "'";
        bidderAssocQueryArr.push({
          query:
            "UPDATE " +
            tablePrefix +
            "rtb_dealid_bidder_assoc set visible=0,date_updated=" +
            DATASOURCE_CONFIG.CURRENT_DATE +
            "  where bidder_id IN (" +
            deleteString +
            ") and dealid='" +
            payload.dealId +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
      if (payload.bidderIds.length > 0) {
        // DELETE PREVIOUS VALUES
        var commonString = "'" + payload.bidderIds.join("','") + "'";
        bidderAssocQueryArr.push({
          query:
            "delete from " +
            tablePrefix +
            "rtb_dealid_bidder_assoc where dealid='" +
            payload.dealId +
            "' and bidder_id IN(" +
            commonString +
            ")",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
    }
    if (payload.bidderAssoc.length > 0) {
      let bidAssocInfoQuery = [];
      payload.bidderAssoc.map((binfo) => {
        bidAssocInfoQuery.push(
          "('" +
            uuid() +
            "','" +
            payload.dealId +
            "','" +
            binfo.bid +
            "','" +
            binfo.pmp +
            "','" +
            binfo.seats +
            "','" +
            binfo.domains +
            "','" +
            binfo.custom_ingestion +
            "', " +
            DATASOURCE_CONFIG.CURRENT_DATE +
            ")"
        );
      });
      var biddersString = "'" + payload.bidderIds.join("','") + "'";

      // INSERT NEW ASSOC VALUES
      bidderAssocQueryArr.push({
        query:
          "insert into " +
          tablePrefix +
          "rtb_dealid_bidder_assoc (dealid_bidders_assoc_id,dealid,bidder_id,private_auction,seat_ids,domains,custom_ingestion,date_updated) values " +
          bidAssocInfoQuery.join(",") +
          " ",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      });
    }

    let dealQuery = [
      {
        query: insertUpdateDealBidderQuery,
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      },
    ];
    const queryArr = [...dealQuery, ...bidderAssocQueryArr];
    const queryBody = {
      queries: queryArr,
      // [
      //   {
      //     query: insertUpdateDealBidderQuery,
      //     datasource: DATASOURCE_CONFIG.DATASOURCE,
      //   },
      // ],
    };
    try {
      const response = await axiosApiInstance.post(
        `${updateDataEndPoint}`,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const CreateUpdatePrivateMarketPlaceLocationDetailsThunk =
  createAsyncThunk(
    "privatemarketplace/CreateUpdatePrivateMarketPlaceLocationDetailsThunk",
    async (payload) => {
      let queriesArr = [];
      var dealId = payload.dealid;
      var action = payload.action;
      if (payload.is_location) {
        let InsertQuery =
          "insert into " +
          tablePrefix +
          "rtb_deals_location_groups (id,deal_id,name,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,target_house_districts,latlon_radius,addresses_radius,poi_radius,geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,creation_date,updated_date,created_by) values";
        let InsertValuesArr = [];
        var locationGroupFieldsInfo = payload.formInfo;

        if (action == "edit" && locationGroupFieldsInfo.length) {
          queriesArr.push({
            query:
              "update " +
              tablePrefix +
              "rtb_deals_location_groups set is_active=0 where  deal_id='" +
              dealId +
              "' ",
            datasource: DATASOURCE_CONFIG.DATASOURCE,
          });
        }
        for (var n = 0; n < locationGroupFieldsInfo.length; n++) {
          var locationInfo = locationGroupFieldsInfo[n];
          console.log("deal-locationInfo:", locationInfo);
          var locId = "";
          if (
            locationInfo.id == "" ||
            locationInfo.id == null ||
            locationInfo.id == undefined
          ) {
            // Create case
            //var insertId = uuid();
            locId = locationInfo.insert_id;
            InsertValuesArr.push(
              "('" +
                locId +
                "','" +
                dealId +
                "','" +
                addslashes(locationInfo.name) +
                "','" +
                locationInfo.target_city +
                "','" +
                locationInfo.target_state +
                "','" +
                locationInfo.target_dma +
                "','" +
                locationInfo.target_counties +
                "','" +
                locationInfo.target_zipcode +
                "','" +
                locationInfo.target_brands +
                "','" +
                locationInfo.target_congressional_districts +
                "','" +
                locationInfo.target_senate_districts +
                "','" +
                locationInfo.target_house_districts +
                "','" +
                locationInfo.latlon_radius +
                "','" +
                locationInfo.addresses_radius +
                "','" +
                locationInfo.poi_radius +
                "','" +
                addslashes(locationInfo.target_latlon) +
                "','" +
                addslashes(locationInfo.target_polygon) +
                "','" +
                addslashes(locationInfo.target_poi) +
                "','" +
                addslashes(locationInfo.target_addresses) +
                "','" +
                locationInfo.target_latlon_group +
                "','" +
                locationInfo.target_polygon_group +
                "','" +
                locationInfo.target_address_group +
                "'," +
                DATASOURCE_CONFIG.CURRENT_DATE +
                "," +
                DATASOURCE_CONFIG.CURRENT_DATE +
                ",'" +
                locationInfo.created_by +
                "')"
            );
            //geo_points,geo_polygons
          } else {
            // Update case
            locId = locationInfo.id;
            queriesArr.push({
              query:
                "update " +
                tablePrefix +
                "rtb_deals_location_groups set is_active=1,target_city='" +
                locationInfo.target_city +
                "',target_state='" +
                locationInfo.target_state +
                "',target_dma='" +
                locationInfo.target_dma +
                "',target_counties='" +
                locationInfo.target_counties +
                "',target_postalcode='" +
                locationInfo.target_zipcode +
                "',target_brands='" +
                locationInfo.target_brands +
                "',target_congressional_districts='" +
                locationInfo.target_congressional_districts +
                "',target_senate_districts='" +
                locationInfo.target_senate_districts +
                "',target_house_districts='" +
                locationInfo.target_house_districts +
                "',latlon_radius='" +
                locationInfo.latlon_radius +
                "',addresses_radius='" +
                locationInfo.addresses_radius +
                "',poi_radius='" +
                locationInfo.poi_radius +
                "',name='" +
                addslashes(locationInfo.name) +
                "',geo_points='" +
                addslashes(locationInfo.target_latlon) +
                "',geo_polygons='" +
                addslashes(locationInfo.target_polygon) +
                "',target_poi='" +
                addslashes(locationInfo.target_poi) +
                "',target_addresses ='" +
                addslashes(locationInfo.target_addresses) +
                "',target_latlon_groups='" +
                locationInfo.target_latlon_group +
                "',target_polygon_groups='" +
                locationInfo.target_polygon_group +
                "',target_address_groups='" +
                locationInfo.target_address_group +
                "',updated_date=" +
                DATASOURCE_CONFIG.CURRENT_DATE +
                " where id='" +
                locationInfo.id +
                "' and deal_id='" +
                dealId +
                "' ",
              datasource: DATASOURCE_CONFIG.DATASOURCE,
            });
          }
        }

        if (InsertValuesArr.length > 0) {
          InsertQuery += InsertValuesArr.join(",");
          queriesArr.push({
            query: InsertQuery,
            datasource: DATASOURCE_CONFIG.DATASOURCE,
          });
        }
      }

      const queryBody = {
        queries: queriesArr,
      };

      try {
        const response = await axiosApiInstance.post(
          updateDataEndPoint,
          queryBody
        );
        console.log("response", response);
        return response;
      } catch (err) {
        // You can choose to use the message attached to err or write a custom error
        console.log("response", err);
      }
    }
  );
export const GetPrivateMarketPlaceDetailsThunk = createAsyncThunk(
  "privatemarketplace/GetPrivateMarketPlaceDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select * from " +
            tablePrefix +
            "rtb_deals where dealid='" +
            payload.id +
            "' and status !='2'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select bidder_id,private_auction as pmp,seat_ids,domains,custom_ingestion from " +
            tablePrefix +
            "rtb_dealid_bidder_assoc where dealid='" +
            payload.id +
            "' and visible=1;",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetPrivateMarketplaceLocationGroupThunk = createAsyncThunk(
  "privatemarketplace/GetPrivateMarketplaceLocationGroupThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          /****get Private Marketpalce location groups data** */
          query:
            "select * from " +
            tablePrefix +
            "rtb_deals_location_groups where deal_id='" +
            payload.id +
            "' and is_active=1",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const UpdatePrivateMarketPlaceStatusThunk = createAsyncThunk(
  "privatemarketplace/UpdatePrivateMarketPlaceStatusThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "rtb_deals set status='" +
            payload.status +
            "',updated=" +
            DATASOURCE_CONFIG.CURRENT_DATE +
            " where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const PrivateMarketPlace = createSlice({
  name: "privatemarketplace",
  initialState,
  reducers: {},

  extraReducers(builder) {
    builder
      .addCase(GetAllPrivateMarketPlaceListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllPrivateMarketPlaceListThunk.fulfilled, (state, action) => {
        if (action.payload.data.results[0]) {
          state.privateMarketPlaceList = action.payload.data.results[0];
        }

        state.loading = false;
      })
      .addCase(GetAllPrivateMarketPlaceListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(CreateUpdatePrivateMarketPlaceDetailsThunk.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(
        CreateUpdatePrivateMarketPlaceDetailsThunk.fulfilled,
        (state, action) => {
          if (
            action.payload.data?.results.length > 0 &&
            action.payload.data.results.includes("Updated")
          ) {
          }
          state.submitLoading = false;
        }
      )
      .addCase(
        CreateUpdatePrivateMarketPlaceDetailsThunk.rejected,
        (state, action) => {
          //toast.error('Something went Wrong!');
          state.submitLoading = false;
        }
      )

      .addCase(
        CreateUpdatePrivateMarketPlaceLocationDetailsThunk.pending,
        (state) => {
          state.submitLoading = true;
        }
      )
      .addCase(
        CreateUpdatePrivateMarketPlaceLocationDetailsThunk.fulfilled,
        (state, action) => {
          if (
            action.payload.data?.results.length > 0 &&
            action.payload.data.results.includes("Updated")
          ) {
            //state.accountsDetails = action.payload.data.results[0];
          }
          state.submitLoading = false;
        }
      )
      .addCase(
        CreateUpdatePrivateMarketPlaceLocationDetailsThunk.rejected,
        (state, action) => {
          //toast.error('Something went Wrong!');
          state.submitLoading = false;
        }
      )
      .addCase(GetPrivateMarketplaceLocationGroupThunk.pending, (state) => {
        state.locationGroupLoading = true;
      })
      .addCase(
        GetPrivateMarketplaceLocationGroupThunk.fulfilled,
        (state, action) => {
          state.locationGroupLoading = false;
        }
      )
      .addCase(
        GetPrivateMarketplaceLocationGroupThunk.rejected,
        (state, action) => {
          //toast.error("Something went Wrong!");
          state.locationGroupLoading = false;
        }
      )
      .addCase(UpdatePrivateMarketPlaceStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        UpdatePrivateMarketPlaceStatusThunk.fulfilled,
        (state, action) => {
          if (action.payload.data?.error == false) {
            let List = state.privateMarketPlaceList;
            let marketPlaceId = action.meta.arg.id;
            let status = action.meta.arg.status;
            if (status == "2") {
              List = List.filter((item) => item.id !== marketPlaceId);
            } else {
              List.map((info) => {
                if (marketPlaceId == info.id) {
                  info.status = status;
                }
                return info;
              });
            }
            state.privateMarketPlaceList = List;
          }
          state.loading = false;
        }
      )
      .addCase(
        UpdatePrivateMarketPlaceStatusThunk.rejected,
        (state, action) => {
          state.loading = false;
        }
      )
      .addCase(GetPrivateMarketPlaceDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetPrivateMarketPlaceDetailsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          //state.CampaignsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.loading = false;
      })
      .addCase(GetPrivateMarketPlaceDetailsThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
      });
  },
});

const { actions, reducer } = PrivateMarketPlace;
// Extract and export each action creator by name
export const {
  // updateDashboardFilter,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
